import { CoreInputModelUtil } from "../utils/CoreInputModelUtil";
import { InputErrorModel } from "./InputErrorModel";

 
export class CoreModel {
    public capitalize(value: string): string {
        // if (!value) {
        //     return '';
        // }

        // return value
        //     .toLowerCase()
        //     .replace(/\b\w/g, (letter: string) => letter.toUpperCase())
        //     .trim();
        return CoreInputModelUtil.capitalize(value);
    }

    public removeWhiteSpace(value: string): string {
        // if (!value) {
        //     return '';
        // }

        // return value.trim();
        return CoreInputModelUtil.removeWhiteSpace(value);
    }

    public isValidString(value: string): boolean {
        // if (!value) return false;
        // return value?.toString().trim().length > 0;
        return CoreInputModelUtil.isValidString(value);
    }

    public isValidNumber(value: number): boolean {
        return value > 0;
    }

    validateTextField<T>(value: string, field: keyof T, errors: InputErrorModel<T>[], index?: number) {
        // if (!this.isValidString(value)) {
        //     errors.push(new InputErrorModel<T>({ field: field, index: index }));
        // }
        CoreInputModelUtil.validateTextField(value, field, errors, index);
    }

    validateDecimalValue<T>(value: string, field: keyof T, errors: InputErrorModel<T>[], index?: number): boolean {
        // if (!this.isValidString(value)) {
        //     errors.push(new InputErrorModel<T>({ field: field, index: index }));
        //     return false;
        // }

        // if (!DecimalRegex.test(value)) {
        //     errors.push(new InputErrorModel<T>({ field: field, index: index }));
        //     return false;
        // }

        // return true;

        return CoreInputModelUtil.validateDecimalValue(value, field, errors, index);
    }

    validateNumber<T>(value: number, field: keyof T, errors: InputErrorModel<T>[]) {
        // if (!this.isValidNumber(value)) {
        //     errors.push(new InputErrorModel<T>({ field: field }));
        // }
        return CoreInputModelUtil.validateNumber(value, field, errors);
    }

    removeSpecialCharactersWithoutSpace(value: string): string {
        // if (!value) {
        //     return '';
        // }
        // return value.replace(/[^a-zA-Z0-9 ]/g, '');
        return CoreInputModelUtil.removeSpecialCharactersWithoutSpace(value);
    }

    addError<T>(field: keyof T, errors: InputErrorModel<T>[], message?: string, index?: number) {
        //  errors.push(new InputErrorModel<T>({ field: field, message: message, index: index }));
        CoreInputModelUtil.addError(field, errors, message, index);
    }
}
